import React, { createContext } from 'react';

import type Tabs from './tabs';

export const TabsContext = createContext<Tabs | null>(null);

export type TabbedPageProps = {
  tabs: Tabs;
  children?: React.ReactNode;
};

function TabbedPage(props: TabbedPageProps): React.JSX.Element {
  const { children, tabs } = props;

  return <TabsContext.Provider value={tabs}>{children}</TabsContext.Provider>;
}

export default TabbedPage;
